import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	footer: {
		id: 'app.program.guideList.footer',
		defaultMessage: '{count, plural, one {# track} other {# tracks}} · {duration}',
		description:
			'Footer under a program\'s session list with the session count and total length, e.g. "7 tracks · 1 hr 13 min"',
	},
	footerDuration: {
		id: 'app.program.guideList.footerDuration',
		defaultMessage: '{hours} hr {minutes} min',
		description: 'Total length in the session list footer. Both units always show, e.g. "0 hr 45 min"',
	},
});
